import { ApiProperty } from "@nestjs/swagger";

export class GantOrderDetailsDto {
   
    @ApiProperty()
    poNumber: string;

    @ApiProperty()
    style?: string;

    @ApiProperty()
    colorCode?: string;

    @ApiProperty()
    itemNo?: string;




}